// @ts-nocheck

export default (outcomeHasOccured, outcomeIsCancelled) => {
  if (outcomeIsCancelled) {
    return '#999';
  }

  if (outcomeHasOccured !== undefined) {
    if (outcomeHasOccured) {
      return '#2abd2a';
    } else {
      return '#ec414a';
    }
  }
  return null;
};
